import { request } from '@umijs/max';

export async function getFeishuAuthUrl(
  scene: 'authorize' | 'qr' = 'authorize',
  options?: { [key: string]: any },
) {
  const response = await request<API.BackendApiResponse<API.FeishuAuthUrlResult>>(
    '/api/auth/url',
    {
      method: 'GET',
      params: { scene },
      ...(options || {}),
    },
  );

  return response.data;
}

export async function loginByFeishuCode(
  body: API.FeishuLoginParams,
  options?: { [key: string]: any },
) {
  const response = await request<API.BackendApiResponse<API.FeishuLoginResult>>(
    '/api/auth/callback',
    {
      method: 'POST',
      data: body,
      ...(options || {}),
    },
  );

  return response.data;
}

export async function getCurrentUserInfo(options?: { [key: string]: any }) {
  const response = await request<API.BackendApiResponse<API.AuthInfoUser>>(
    '/api/auth/info',
    {
      method: 'GET',
      ...(options || {}),
    },
  );

  return response.data;
}
